<template lang='pug'>
	.terms(id='home')
		v-e24-nav-bar
		headerResources(:srcImage='img', :tall="tall", h1="EasyTitle24.com Terms and Conditions")
		contentTerms
		v-e24-footer(:build="build")
</template>

<script>
import headerResources from '@/commonSite/header.vue'
import contentTerms from '@/components/resources/content-terms.vue'
import imageHeader from '@/img/terms-header.jpg'
import readBuild from '../util/readBuild'

export default {
	name: 'terms-and-conditions',
	components: {
		headerResources,
		contentTerms
	},
	mixins: [readBuild],
	mounted () {
		this.build = this.getBuild()
	},
	data: function () {
		return {
			build: '',
			img: imageHeader,
			tall: 90
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/views/TermsAndConditions.vue